import { render, staticRenderFns } from "./adtwo.vue?vue&type=template&id=22d652e0&scoped=true"
import script from "./adtwo.vue?vue&type=script&lang=js"
export * from "./adtwo.vue?vue&type=script&lang=js"
import style0 from "./adtwo.vue?vue&type=style&index=0&id=22d652e0&prod&scoped=true&lang=css"
import style1 from "./adtwo.vue?vue&type=style&index=1&id=22d652e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d652e0",
  null
  
)

export default component.exports